import { CrudEntity, CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';

export const STANDARD_GRAPH_AXIS_ID_DEFAULT = { value: null, label: null };
const VISUAL_VALUE_TRANSFORM_TYPE_ID_DEFAULT = { value: 0, label: '' };

export default class ObservationTypeService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Observation Type';
    const entityPluralName = 'Observation Types';
    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: EntityProps): any {
    const { entity, values, getdataTypeId, ...rest } = props;

    return {
      ...entity,
      Name: values.name,
      DisplayName: values.displayname,
      Definition: values.definition,
      GraphVisualizationTypeId:
        values.graphvisualizationtypeid && !isValueEmpty(values.graphvisualizationtypeid.value)
          ? values.graphvisualizationtypeid.value
          : null,
      UnitOfMeasureId: values.unitofmeasureid ? values.unitofmeasureid.value : null,
      StandardGraphAxisId:
        values.standardgraphaxisid && !isValueEmpty(values.standardgraphaxisid.value)
          ? values.standardgraphaxisid.value ?? null
          : null,
      LowerLimit: !isValueEmpty(values.lowerlimit) && values.isactive === 'Numeric' ? values.lowerlimit : null,
      Upperlimit: !isValueEmpty(values.upperlimit) && values.isactive === 'Numeric' ? values.upperlimit : null,
      Displayformat: values.displayformat ?? '',
      DataTypeId: getdataTypeId(values.isactive),
      VisualValueTransformTypeId: values.visualvaluetransformtypeid
        ? values.visualvaluetransformtypeid.value && values.visualvaluetransformtypeid.value !== 0
          ? values.visualvaluetransformtypeid.value
          : null
        : null,
      GraphDefaultColorCode: values.graphcolor,
      ObservationCategoryId: values.observationcategoryid.value,
    };
  }

  mapInitialValues(props: EntityProps): any {
    const { entity, ...rest } = props;

    const result = {
      name: entity.Name ?? '',
      displayname: entity.DisplayName ?? '',
      definition: entity.Definition ?? '',
      graphvisualizationtypeid: entity.GraphVisualizationTypeId
        ? {
            value: entity.GraphVisualizationTypeId,
            label: entity.GraphVisualizationTypeName,
          }
        : { value: null, label: null },
      standardgraphaxisid: entity.StandardGraphAxisId
        ? { value: entity.StandardGraphAxisId, label: entity.StandardGraphAxisName }
        : STANDARD_GRAPH_AXIS_ID_DEFAULT,
      unitofmeasureid: entity.UnitOfMeasureId
        ? { value: entity.UnitOfMeasureId, label: entity.Abbreviation }
        : { value: 0, label: '' },
      lowerlimit: entity.LowerLimit ?? '',
      upperlimit: entity.UpperLimit ?? '',
      displayformat: entity.DisplayFormat ?? '',
      isactive: entity.WagDataType ? entity.WagDataType.Name ?? 'Numeric' : 'Numeric',
      visualvaluetransformtypeid: entity.VisualValueTransformTypeId
        ? {
            value: entity.VisualValueTransformTypeId,
            label: entity.VisualValueTransformTypeName,
          }
        : VISUAL_VALUE_TRANSFORM_TYPE_ID_DEFAULT,
      graphcolor: entity.GraphDefaultColorCode,
      observationcategoryid: entity.ObservationCategoryId ?? '',
    };

    return result;
  }

  cleanFormValues(props: EntityProps): any {
    const { entity, ...rest } = props;

    return {
      ...entity,
      graphcolor: isValueEmpty(entity.graphcolor) ? null : entity.graphcolor,
      graphvisualizationtypeid:
        entity.graphvisualizationtypeid && !isValueEmpty(entity.graphvisualizationtypeid.value)
          ? entity.graphvisualizationtypeid.value
          : null,
      standardgraphaxisid:
        entity.standardgraphaxisid && !isValueEmpty(entity.standardgraphaxisid.value)
          ? entity.standardgraphaxisid.value ?? null
          : null,
      visualvaluetransformtypeid: entity.visualvaluetransformtypeid
        ? entity.visualvaluetransformtypeid.value && entity.visualvaluetransformtypeid.value !== 0
          ? entity.visualvaluetransformtypeid.value
          : null
        : null,
    };
  }
}
